(function () {
  var INCH_TO_CM = 2.54;

  function convertValue(text, toCm) {
    if (text.includes("-")) {
      var parts = text.split("-");
      var converted = parts.map(function (p) {
        var num = parseFloat(p.trim());
        if (isNaN(num)) return p;
        var result = toCm ? num * INCH_TO_CM : num / INCH_TO_CM;
        return Math.round(result * 10) / 10;
      });
      return converted.join("-");
    }
    var num = parseFloat(text);
    if (isNaN(num)) return text;
    var result = toCm ? num * INCH_TO_CM : num / INCH_TO_CM;
    return Math.round(result * 10) / 10;
  }

  function isNumericCell(text) {
    return /^[\d.\-\s]+$/.test(text.trim());
  }

  function createButton(label, isActive) {
    var btn = document.createElement("button");
    btn.className = "size-chart-unit-switcher__btn";
    if (isActive) btn.className += " size-chart-unit-switcher__btn--active";
    btn.setAttribute("data-unit", label);
    btn.textContent = label;
    return btn;
  }

  function initSwitcher(modal) {
    if (modal.querySelector(".size-chart-unit-switcher")) return;

    var table = modal.querySelector("table");
    if (!table) return;

    var cells = table.querySelectorAll("td");
    cells.forEach(function (cell) {
      cell.setAttribute("data-inches", cell.textContent.trim());
    });

    var switcher = document.createElement("div");
    switcher.className = "size-chart-unit-switcher";

    var toggle = document.createElement("div");
    toggle.className = "size-chart-unit-switcher__toggle";

    var btnIn = createButton("inches", true);
    var btnCm = createButton("cm", false);
    toggle.appendChild(btnIn);
    toggle.appendChild(btnCm);
    switcher.appendChild(toggle);

    table.parentNode.insertBefore(switcher, table);

    var buttons = [btnIn, btnCm];
    buttons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var unit = btn.getAttribute("data-unit");
        var toCm = unit !== "inches";

        buttons.forEach(function (b) {
          b.classList.remove("size-chart-unit-switcher__btn--active");
        });
        btn.classList.add("size-chart-unit-switcher__btn--active");

        cells.forEach(function (cell) {
          var original = cell.getAttribute("data-inches");
          if (!isNumericCell(original)) return;
          cell.textContent = toCm ? convertValue(original, true) : original;
        });
      });
    });
  }

  var observer = new MutationObserver(function () {
    var modal = document.querySelector(
      ".Vtl-SizeChartModal .Vtl-SizeChartModalContent__Content",
    );
    if (modal) initSwitcher(modal);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  var existing = document.querySelector(
    ".Vtl-SizeChartModal .Vtl-SizeChartModalContent__Content",
  );
  if (existing) initSwitcher(existing);
})();
